export class AppSettings {
  async Init() {}

  apiBasePath() {
    return process.env.API_URL
  }

  envmode() {
    return process.env.NODE_ENV
  }
}



// WEBPACK FOOTER //
// ./src/appmodules/appsettings.js